<div class="info-template">
  <ng-content></ng-content>    
</div>